import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class BidderDomainsStatesRoutes extends BaseRoutes {
	constructor() {
		super('bidder-domains-states');
	}
}
